import { faFile } from '@fortawesome/pro-light-svg-icons';
import { SvgIconProps } from '@mui/material';
import { FontAwesomeSvgIcon } from '../../../../common/components/atoms/FontAwesomeIcon';

export default function FileIcon(props: SvgIconProps) {
  return <FontAwesomeSvgIcon sx={{ color: 'primaryText.100' }} {...props} icon={faFile} />;
}
